const APROBADA = 'APRO'
const CERRADA = 'CERR'
const ABIERTA = 'ABIE'
const RECHAZADA = 'RECH'
const PENDIENTE = 'PEND'
const ATENDIDO = 'ATEN'
const ANULADO = 'ANUL'
const OBSERVADA = 'OBSE'

const __dictionary = {
  [APROBADA]: {
    id: APROBADA,
    nombre: 'APROBADA',
    color: 'success'
  },
  [CERRADA]: {
    id: CERRADA,
    nombre: 'CERRADA',
    color: 'secondary'
  },
  [ABIERTA]: {
    id: ABIERTA,
    nombre: 'PEND. APROBACIÓN',
    color: 'info'
  },
  [RECHAZADA]: {
    id: RECHAZADA,
    nombre: 'RECHAZADA',
    color: 'danger'
  },
  [PENDIENTE]: {
    id: PENDIENTE,
    nombre: 'PENDIENTE',
    color: 'warning'
  },
  [ATENDIDO]: {
    id: ATENDIDO,
    nombre: 'ATENDIDO',
    color: 'primary'
  },
  [ANULADO]: {
    id: ANULADO,
    nombre: 'ANULADO',
    color: 'dark'
  },
  [OBSERVADA]: {
    id: OBSERVADA,
    nombre: 'OBSERVADA',
    color: 'warning'
  }
}

const __array = [
  __dictionary[ABIERTA],
  __dictionary[APROBADA],
  __dictionary[PENDIENTE],
  __dictionary[ATENDIDO],
  __dictionary[CERRADA],
  __dictionary[RECHAZADA],
  __dictionary[ANULADO],
  __dictionary[OBSERVADA]
]

const __vaues = [APROBADA, CERRADA, ABIERTA, RECHAZADA, PENDIENTE, ATENDIDO, ANULADO, OBSERVADA]

export default Object.freeze({
  APROBADA,
  CERRADA,
  ABIERTA,
  RECHAZADA,
  PENDIENTE,
  ATENDIDO,
  ANULADO,
  OBSERVADA,
  __dictionary,
  __array,
  __vaues
})
